import { maybeJsonDateStringParser } from "./maybeJsonDateStringParser";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const jsonReviver = (_: string, value: any): Date | any => {
  return maybeJsonDateStringParser(value);
};
